import { Datasheet } from "@/api/datasheets";
import { InspectorRow, InspectorWeld } from "@/api/hitachi/rbi";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";

export type Ndt = {
  discipline: string;
};

export type InspectorState = {
  project?: Project;
  subProject?: SubProject;
  datasheet?: Datasheet;
  discipline: string;
  operation?: string;
  welds: InspectorWeld[];
  inspections: InspectorRow[];
  filters: WeldListFilters;
};

export type WeldListFilters = {
  onlyWeldsReadyForNdt: boolean;
  onlyRepairOrRewelds: boolean;
};

export const defaultFilters: WeldListFilters = {
  onlyWeldsReadyForNdt: true,
  onlyRepairOrRewelds: false,
};

export const defaultState: InspectorState = {
  welds: [],
  inspections: [],
  filters: defaultFilters,
  discipline: "BWI",
};

export type StateType =
  | "Project"
  | "SubProject"
  | "Datasheet"
  | "Discipline"
  | "Operation"
  | "Welds"
  | "Inspections"
  | "Filters";

export type Inventory =
  | "PTCleaner"
  | "PTPenetrant"
  | "PTDeveloper"
  | "UTTestEquipment"
  | "UTCalibrationBlocks"
  | "UTProbe"
  | "ETTestEquipment"
  | "ETCalibrationBlocks"
  | "ETProbe"
  | "Couplant";

export const InventoryMap: Record<Inventory, string> = {
  PTCleaner: "33ac4d0b-028c-422c-ac8e-fdfa18d8d5fe",
  PTPenetrant: "2b9d857a-a510-446a-899e-ac8a9459d982",
  PTDeveloper: "9409de63-5ef1-4609-be75-bcbd04921a91",
  UTTestEquipment: "3dc02b1a-83f8-4d4f-8191-e6da2a5257c2",
  UTCalibrationBlocks: "0115ff10-9e23-4843-9cbc-4f6e89daf43a",
  UTProbe: "57ffb7de-056f-42fd-b1b7-efe8c215a086",
  ETTestEquipment: "fd73c0e2-9a3a-4e23-81a8-b0fb3eac4e0d",
  ETCalibrationBlocks: "04d8e383-0d7c-4501-8d58-41060a9a479b",
  ETProbe: "1e737b8d-fa54-49f6-8500-d7afe9749529",
  Couplant: "66f6b5f3-ce8b-427d-b111-3be32818e3da",
};
